import { useUser } from '@/Utility/hooks';
import { AccountBox } from '@mui/icons-material';
import { ToggleButton, Tooltip } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { z } from 'zod';
import { FilterBadge } from '../components/FilterBadge';
import { __useFilterState } from '../useFilterState';

const myZnglySearchSchema = z.object({
  author: z.array(z.string()).nullish(),
});

const MyZnglyFilter = () => {
  const { fastFilters: filters, updateFilter, isUpdating } = __useFilterState(myZnglySearchSchema);
  const { id: userId } = useUser();

  const isMyZnglyActive = useCallback(() => {
    if (!userId) return false;

    if (filters?.author?.length !== 1) return false;
    return filters.author[0] === userId;
  }, [filters?.author, userId]);

  const [isActive, setIsActive] = useState(isMyZnglyActive());

  const handleClick = useCallback(() => {
    if (!userId) return;

    setIsActive((prev) => !prev);

    updateFilter((prev) => {
      if (prev?.author?.length === 1 && prev.author[0] === userId) {
        return { author: undefined };
      }
      return { author: [userId] };
    });
  }, [updateFilter, userId]);

  useEffect(() => {
    setIsActive(isMyZnglyActive());
  }, [filters?.author, userId]);

  if (!userId) return null;

  return (
    <div style={{ position: 'relative' }}>
      <Tooltip title="MyZngly - Filter content created by you">
        <ToggleButton className="z-btn-toggle" value="my-zngly" selected={isActive} onClick={handleClick}>
          <AccountBox />
        </ToggleButton>
      </Tooltip>

      <FilterBadge count={isActive} isUpdating={isUpdating} />
    </div>
  );
};

const MyZnglyFilterMemo = React.memo(MyZnglyFilter);

export const FilterConfig_MyZngly = {
  myZngly: {
    searchSchema: myZnglySearchSchema,
    component: MyZnglyFilterMemo,
    componentProps: {},
  },
} as const;
